import { Permission, RawPermission } from './role-types';

export const getRobotPermission = (
  robotId: number,
  rawPermissions: string[],
  permission: Permission,
) => {
  const wantedPermission: RawPermission = `robot:${robotId}:${permission}`;
  return rawPermissions.includes(wantedPermission);
};
